import React, { useState } from 'react';
import axios from '../../node_modules/axios/index';
import succesIMG from "../Images/PaymentSuccess/success.svg";
import failIMG from "../Images/PaymentSuccess/failed.svg";
import alertIMG from "../Images/PaymentSuccess/alert.svg";
import pdfIMG from "../Images/PaymentSuccess/pdf-download.svg";
const PaymentSuccessOrFailDumy = (props) => {
    const [PdfBytes, setPDFBytes] = useState("");
    let InsurerLogo = "";
    let CompanyName = "";
    let portalurl = "https://www.smcinsurance.com";
    const url = new URLSearchParams(window.location.search);
    const PaymentStatus = url.get("PaymentStatus");
    const Premium = url.get("TotalPremium");
    const TransectionID = url.get("TransectionID");
    const PolicyNo = url.get("PolicyNo");
    const Path = url.get("pdfPath");
    const EnquiryNo = url.get("EnquiryNo");
    const InsurerID = url.get("InsurerID");
    const LeadEnq = window.localStorage.getItem("LeadEnq");
    switch (InsurerID) {
        case "100":
            InsurerLogo = portalurl + "/insurer logo/liberty.png";
            CompanyName = "Liberty"
            break;
        case "101":
            InsurerLogo = portalurl + "/insurer logo/tata.png";
            CompanyName = "Tata";
            break;
        case "102":
            InsurerLogo = portalurl + "/insurer logo/bajaj.png";
            CompanyName = "Bajaj";
            break;
        case "103":
            InsurerLogo = portalurl + "/insurer logo/hdfc.png";
            CompanyName = "HDFC";
            break;
        case "104":
            InsurerLogo = portalurl + "/insurer logo/star.jpg";
            CompanyName = "Star";
            break;
        case "105":
            InsurerLogo = portalurl + "/insurer logo/universal.png";
            CompanyName = "Universal Sompo";
            break;
        case "107":
            InsurerLogo = portalurl + "/insurer logo/iffco.png";
            CompanyName = "Iffco";
            break;
        case "108":
            InsurerLogo = portalurl + "/insurer logo/future.png";
            CompanyName = "Future"
            break;
        case "111":
            InsurerLogo = portalurl + "/insurer logo/sundaram.png";
            CompanyName = "Royal Sundaram";
            break;
        case "112":
            InsurerLogo = portalurl + "/insurer logo/realince.png";
            CompanyName = "Reliance"
            break;
        case "113":
            InsurerLogo = portalurl + "/insurer logo/kotak.png";
            CompanyName = "Kotak"
            break;
        case "114":
            CompanyName = "Care";
            InsurerLogo = portalurl + "/insurer logo/religare.png";
            break;
        case "116":
            InsurerLogo = portalurl + "/insurer logo/Birla.jpg";
            CompanyName = "Aditya Birla";
            break;
        case "118":
            CompanyName = "Sriram";
            InsurerLogo = portalurl + "/insurer logo/shriram.png";
            break;
        case "121":
            InsurerLogo = portalurl + "/insurer logo/united.png";
            CompanyName = "NIC";
            break;
        case "124":
            InsurerLogo = portalurl + "/insurer logo/godigit.png";
            CompanyName = "Digit"; //confirm
            break;
        case "126":
            InsurerLogo = portalurl + "/insurer logo/Icici.png";
            CompanyName = "ICICI Lombard";
            break;
        case "128":
            InsurerLogo = portalurl + "/insurer logo/nic.png";
            CompanyName = "NIC";
            break;
        case "150":
            InsurerLogo = portalurl + "/insurer logo/CholaMs.png";
            CompanyName = "Chola Mandalam";
            break;
        case "154":
            InsurerLogo = portalurl + "/insurer logo/Zuno.jpg";
            CompanyName = "Zuno";
            break;
    }



    const GetPolicyPDF = () => {
        axios.post("/central/centralcall/CallReqWithHeader", {
            URL: "DownloadPolicyPDF", Props: [EnquiryNo, InsurerID]
        }).then(Res => {
            //console.log(Res.data);
            if (Res.data.statusCode === 200) {
                localStorage.removeItem("ProceedWithSame");
                localStorage.removeItem("QuoteResponse");
                localStorage.removeItem("QuoteRequest");

                setPDFBytes(Res.data.response);
                const bytesArray = base64ToArrayBuffer(Res.data.response);
                saveByteArray(`${PolicyNo}`, bytesArray);
            }
        });
    }
    function base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }
    function saveByteArray(reportName, byte) {
        var blob = new Blob([byte], { type: "application/pdf" });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var fileName = reportName;
        link.download = fileName;
        link.click();
    };
    return (
        <section className="PayThanksPage">
            <div className="container">
                <div className="PayThanksPageBox">
                    <div className="PayThanksPageBox1">
                        {PaymentStatus == "True" ?
                            <React.Fragment>
                                <img src={succesIMG} />
                                <h1 className="PayThanksTitle">
                                    Your payment was <span>successful.</span>
                                </h1>
                            </React.Fragment> : PaymentStatus == "False" ?
                                <React.Fragment>
                                    <img src={failIMG} />
                                    <h1 className="PayThanksTitle">
                                        Ooops! Payment <span className="failed">failed.</span>
                                    </h1>

                                </React.Fragment> :
                                <React.Fragment>
                                    <img src={alertIMG} />
                                    <h1 className="PayThanksTitle">
                                        It seems there is an issue.

                                    </h1>
                                    <small>Wait for at least 24 hours, you will receive an update on your registered email id.</small>
                                </React.Fragment>
                        }
                    </div>
                    <div className="PayThanksPageBox2">
                        {(PaymentStatus === "True" || PaymentStatus === "False") && < div className="innerBox">
                            {PaymentStatus !== "False" ? <h3>Your online policy Purchase ID: <span>{props.IsLoader ? "Loading.." : TransectionID}</span></h3> : <h3>Your online policy Transaction ID: <span>{props.IsLoader ? "Loading.." : TransectionID}</span></h3>}
                            {PaymentStatus !== "False" && <h3>Your online policy No: <span>{props.IsLoader ? "Loading.." : PolicyNo}</span></h3>}
                            {PaymentStatus !== "False" && <p>{props.IsLoader ? "Loading.." : "Your policy document:"}  <a onClick={GetPolicyPDF}><img src={pdfIMG} /></a></p>}
                        </div>}

                        <div className="innerBoxOf">
                            <div className="innerBox">
                                {props.IsLoader ? "Loading.." : <img src={InsurerLogo} alt="Payment Logo" />}
                            </div>
                            <div className="innerBox">
                                <h4>Total Premium</h4>
                                <h5>{props.IsLoader ? "Loading.." : Premium ? ("₹ " + Premium) : "Not Available"}</h5>
                            </div>
                        </div>
                        {PaymentStatus === "True" ? <p>If you are not able to download policy documents from above link. You will get policy documents on your registerd Email ID. </p> : <p>Dear Customer, your payment transaction has failed. Please try again. In case the amount has been deducted from your account, it will be refunded within 2-3 working days.</p>}

                    </div>
                </div>
            </div>
        </section>
    )
}

export default PaymentSuccessOrFailDumy